import React from 'react';
import Navbar from './ResponsiveAppBar';

const Header = () => {
  return (
    <header>
      <Navbar />
    </header>
  );
};

export default Header;
